<template>
  <v-container>
    <v-layout justify-center>
      <v-flex md12 v-if="isAdmin">
        <v-tabs
          v-model="currentItem"
          color="transparent"
          slider-color="blue"
        >
          <v-tab
            key="item2"
          >
            Konfiguration
          </v-tab>
          <v-tab
            key="item1"
          >
            Test links
          </v-tab>
          <v-tab-item>
            <v-container>
              <v-flex xs3>
                <v-text-field v-model="clientNr" label="AuftraggeberNr"></v-text-field>
                <v-btn block @click="setDebug(true)" small color='blue' dark class="text-none">Debug aktivieren</v-btn>
                <v-btn block outline @click="setDebug(false)" small color='red' dark class="text-none">Debug deaktivieren</v-btn>
                <v-btn block @click="setLogging(true)" small color='blue' dark class="text-none">Logging aktivieren</v-btn>
                <v-btn block outline @click="setLogging(false)" small color='red' dark class="text-none">Logging deaktivieren</v-btn>

              </v-flex>

            </v-container>
          </v-tab-item>
          <v-tab-item>
            <v-container>
              <v-layout row wrap>
                <v-flex class="pa-2">
                  <v-btn block @click="setLocale()" small color='blue' dark class="text-none mx-3">Zeige I18N keys
                  </v-btn>
                </v-flex>
                <v-flex class="pa-2">
                  <v-btn block @click="open('/tests/test.html')" small color='blue' dark
                         class="text-none mx-3">Alle Waimea Tests
                  </v-btn>
                </v-flex>
                <!--
                <v-btn @click="open('api/tests/testBalanceAndPeergroup.html')">Peergroup Test</v-btn>
                <v-btn @click="open('api/tests/testHitlistBalances.html')">Trefferliste Bilanzen</v-btn>
                <v-btn @click="open('api/tests/testHitlistCompanies.html')">Trefferliste Unternehmen</v-btn>
                <v-btn @click="open('api/tests/testExcelAkte.html')">Excel Export</v-btn>
                <v-btn @click="open('api/tests/testAkte.html')">Test Akte</v-btn>
                <v-btn @click="open('api/tests/testKDF.html')">Test KDF</v-btn>
                <v-btn @click="open('api/tests/testHyperSearch.html')">Globale Suche</v-btn>
                -->
                <v-flex class="pa-2">
                  <v-btn block to='/di/AdminLog' small color='blue' dark
                         class="text-none mx-3">Logging
                  </v-btn>
                </v-flex>
                <v-flex class="pa-2">
                  <v-btn block @click="open('/LogReader.php')" small color='blue' dark
                         class="text-none mx-3">PHP Log
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-tab-item>
        </v-tabs>
      </v-flex>
      <v-flex v-else>
        Kein Admin Recht.
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'Administration',
  components: {},
  data () {
    return {
      api: require('./adminApi').default,
      currentItem: null,
      clientNr: 463,
      isAdmin: false
    }
  },
  methods: {
    setDebug: function (isDebug) {
      this.api.setDebugging(isDebug, this.clientNr, this.onDone)
    },
    onDone: function (res) {
      Vue.prototype.$api.debug('configuration done', res)
    },
    setLogging: function (isDebug) {
      this.api.setLogging(isDebug, this.clientNr, this.onDone)
    },
    open: function (url) {
      let lurl = Vue.prototype.$config.HOST + url
      console.log('open', lurl, Vue.prototype.$config.HOST, url)
      window.location = lurl
    },
    setLocale: function () {
      Vue.prototype.$config.language = 'dummy'
      Vue.i18n.set('dummy')
    }
  },
  mounted () {
    // Vue.prototype.$api.checkCredentials(this) trans
    this.isAdmin = Vue.prototype.$api.isAdmin()
    Vue.prototype.$api.getBreadCrumpModule()
    Vue.prototype.$eventHub.$emit('OnGetModuleTitle', Vue.i18n.translate('LABEL_MODULE_ADMINISTRATION')) //LABEL_MODULE_PASSWORD_RESET
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/Administration.vue